import React, { ReactNode } from 'react';
import styles from '../styles.module.css';

export default function PageCardHeader({
  title,
  text,
  backgroundIcon = '#fff',
  icon,
  iconClass = '',
  titleClass = '',
  noIconWidth = false,
  textClass = '',
  className = '',
}: {
  children?: ReactNode;
  className?: string;
  title?: string | ReactNode;
  text?: string | ReactNode;
  aside?: ReactNode;
  backgroundIcon?: string;
  icon?: ReactNode;
  iconClass?: string;
  titleClass?: string;
  noIconWidth?: boolean;
  textClass?: string;
}) {
  return (
    <div className={`${styles.headerMain} ${className}`}>
      {icon && (
        <span
          className={`${styles.iconTile} ${noIconWidth && styles.noIconWidth} ${iconClass}`}
          style={{ background: backgroundIcon }}
        >
          {icon}
        </span>
      )}
      <div>
        {title && <div className={`${styles.title} ${titleClass}`}>{title}</div>}
        {text ? <div className={`${styles.sub} ${textClass}`}>{text}</div> : null}
      </div>
    </div>
  );
}
